<div class="card sankey-card">
  <div class="card-body">
    <div class="d-flex align-items-center gap-2">
      <div>
        <div class="subheader">@if (iconSvg) { <app-dashboard-icon [svg]="iconSvg" class="me-2"></app-dashboard-icon> } {{ title }}</div>
        <div class="text-secondary small">Posted income, costs, working capital, and cash movements</div>
      </div>
      <div class="ms-auto lh-1 range-control">
        <button type="button" class="btn btn-link btn-sm dropdown-toggle text-secondary p-0" [attr.aria-expanded]="rangeOpen" aria-label="Select cash flow time range" (click)="rangeOpen = !rangeOpen">{{ selectedWindow.label }}</button>
        @if (rangeOpen) {
          <div class="dropdown-menu dropdown-menu-end show">
            @for (option of timeWindowOptions; track option.label; let index = $index) {
              <button type="button" class="dropdown-item" [class.active]="index === selectedWindowIndex" (click)="selectWindow(index)">{{ option.label }}</button>
            }
          </div>
        }
      </div>
    </div>

    @if (loading) {
      <div class="widget-loading"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span>Loading cash flow…</div>
    } @else if (error) {
      <div class="widget-error mt-3" role="alert">{{ error }}</div>
    } @else {
      <div class="sankey-totals">
        <div><span class="text-secondary small">Cash at end</span><strong>{{ money(cashAtEnd) }}</strong></div>
        <div><span class="text-secondary small">Net profit</span><strong [class.text-danger]="netProfit < 0">{{ money(netProfit) }}</strong></div>
      </div>
      @if (hasCashActivity || profitFlow.sources.length) {
        <div class="flow-title"><strong>How income became profit</strong><span>{{ money(revenue) }} sales revenue</span></div>
        <svg class="sankey" viewBox="0 0 870 255" role="img" [attr.aria-label]="'Profit Sankey. Net profit ' + money(netProfit)">
          @for (link of profitFlow.incoming; track link.label) {
            <path [attr.d]="link.path" [attr.fill]="link.color" fill-opacity="0.38"><title>{{ link.label }}: {{ money(link.value) }}</title></path>
          }
          @for (link of profitFlow.outgoing; track link.label) {
            <path [attr.d]="link.path" [attr.fill]="link.color" fill-opacity="0.38"><title>{{ link.label }}: {{ money(link.value) }}</title></path>
          }
          <rect x="427" y="42" width="16" [attr.height]="profitFlow.centerHeight" rx="3" fill="#495057" />
          <text x="435" y="30" text-anchor="middle" class="sankey-heading">Total income</text>
          @for (node of profitFlow.sources; track node.label) {
            <rect x="178" [attr.y]="node.y" width="16" [attr.height]="node.height" rx="3" [attr.fill]="node.color" />
            <text x="168" [attr.y]="node.y + node.height / 2" text-anchor="end" dominant-baseline="middle" class="sankey-label">{{ node.label }}</text>
            <text x="168" [attr.y]="node.y + node.height / 2 + 15" text-anchor="end" dominant-baseline="middle" class="sankey-value">{{ money(node.value) }}</text>
          }
          @for (node of profitFlow.uses; track node.label) {
            <rect x="676" [attr.y]="node.y" width="16" [attr.height]="node.height" rx="3" [attr.fill]="node.color" />
            <text x="702" [attr.y]="node.y + node.height / 2" dominant-baseline="middle" class="sankey-label">{{ node.label }}</text>
            <text x="702" [attr.y]="node.y + node.height / 2 + 15" dominant-baseline="middle" class="sankey-value">{{ money(node.value) }}</text>
          }
        </svg>
        <div class="flow-divider"></div>
        <div class="flow-title"><strong>How profit became cash</strong><span>Accrual-to-cash bridge</span></div>
        <svg class="sankey" viewBox="0 0 870 255" role="img" [attr.aria-label]="'Cash flow Sankey. Closing cash ' + money(cashAtEnd)">
          @for (link of cashFlow.incoming; track link.label) {
            <path [attr.d]="link.path" [attr.fill]="link.color" fill-opacity="0.38"><title>{{ link.label }}: {{ money(link.value) }}</title></path>
          }
          @for (link of cashFlow.outgoing; track link.label) {
            <path [attr.d]="link.path" [attr.fill]="link.color" fill-opacity="0.38"><title>{{ link.label }}: {{ money(link.value) }}</title></path>
          }
          <rect x="427" y="42" width="16" [attr.height]="cashFlow.centerHeight" rx="3" fill="#495057" />
          <text x="435" y="30" text-anchor="middle" class="sankey-heading">Cash available</text>
          @for (node of cashFlow.sources; track node.label) {
            <rect x="178" [attr.y]="node.y" width="16" [attr.height]="node.height" rx="3" [attr.fill]="node.color" />
            <text x="168" [attr.y]="node.y + node.height / 2" text-anchor="end" dominant-baseline="middle" class="sankey-label">{{ node.label }}</text>
            <text x="168" [attr.y]="node.y + node.height / 2 + 15" text-anchor="end" dominant-baseline="middle" class="sankey-value">{{ money(node.value) }}</text>
          }
          @for (node of cashFlow.uses; track node.label) {
            <rect x="676" [attr.y]="node.y" width="16" [attr.height]="node.height" rx="3" [attr.fill]="node.color" />
            <text x="702" [attr.y]="node.y + node.height / 2" dominant-baseline="middle" class="sankey-label">{{ node.label }}</text>
            <text x="702" [attr.y]="node.y + node.height / 2 + 15" dominant-baseline="middle" class="sankey-value">{{ money(node.value) }}</text>
          }
        </svg>
        <div class="sankey-caption text-secondary small">The first flow reconciles income to profit. The second explains the working-capital and financing movements between profit and closing cash.</div>
      } @else {
        <div class="sankey-empty text-secondary">No posted cash movements in this period.</div>
      }
    }
  </div>
</div>
